interface LoadingProps {
  label?: string;
}

export function Loading({ label = '加载中…' }: LoadingProps) {
  return (
    <div className="status-box" role="status">
      <span className="spinner" aria-hidden="true" />
      <p>{label}</p>
    </div>
  );
}

interface ErrorBoxProps {
  title?: string;
  message: string;
  onRetry?: () => void;
}

export function ErrorBox({ title = '出错了', message, onRetry }: ErrorBoxProps) {
  return (
    <div className="status-box error" role="alert">
      <p className="status-title">{title}</p>
      <p className="status-msg">{message}</p>
      {onRetry && (
        <button type="button" className="btn btn-ghost btn-sm" onClick={onRetry}>
          重试
        </button>
      )}
    </div>
  );
}
